var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWsaVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 1240,
    viewBox: "0 0 373 1240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.682 0.75H57.2057L0 1301.75H373C247.612 632.693 239.21 155.643 250.682 0.75Z",
    fill: "#42A1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsaVector3);
export default __webpack_public_path__ + "static/media/wsa_vector3.07629cdc2cdd186af6f93401ad2c26e3.svg";
export { ForwardRef as ReactComponent };